
<v-ace-editor
  :value="value"
  lang="json"
  theme="chrome"
  :height="height"
  class="ace-editor"
  @init="initAceEditor"
/>
